import React, { useEffect, useRef, useState } from "react";

const LoadingAnimation = () => {
  const canvasRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(true);
  let animationFrame = null;
  let rectAngle = 0;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const width = canvas.width;
    const height = canvas.height;
    const rectWidth = width / 3.4;
    const rectHeight = height / 3.4;
    const radius = rectWidth * 0.78;
    const centerX = width / 2;
    const centerY = height / 2;
    const colors = ["rgb(0, 51, 102)", "rgb(255, 0, 0)"];
    const offsets = [0, 90, 180, 270];

    const animate = () => {
      if (!isAnimating) return;

      ctx.clearRect(0, 0, width, height);
      rectAngle = (rectAngle + 4) % 360;

      const calculatePosition = (angleOffset) => {
        const angle = ((rectAngle + angleOffset) % 360) * (Math.PI / 180);
        return {
          x: centerX + radius * Math.cos(angle),
          y: centerY + radius * Math.sin(angle),
        };
      };

      const drawRectangle = (x, y, color) => {
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate((45 * Math.PI) / 180);
        ctx.fillStyle = color;
        ctx.fillRect(-rectWidth / 2, -rectHeight / 2, rectWidth, rectHeight);
        ctx.restore();
      };

      offsets.forEach((offset, index) => {
        const pos = calculatePosition(offset);
        drawRectangle(pos.x, pos.y, colors[index % 2]);
      });

      animationFrame = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(animationFrame);
  }, [isAnimating]);

  return (
    <div className="loader-container">
      <div className="p-7 rounded-2xl bg-white">
        <canvas ref={canvasRef} width="80" height="80"></canvas>
      </div>
    </div>
  );
};

export default LoadingAnimation;
